import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import {
  Explainer as ExplainerPrimitive,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from '@/components/NCExplainers/Explainer';

export type ExplainerProps = {
  title?: string;
  explainers: {
    title: string;
    body: string;
  }[];
  externalLink?: string;
};

export const Explainer = ({ title, explainers, externalLink }: ExplainerProps) => {
  const { t } = useTranslation();

  const explainerTitle = title ?? t('global.howDoWeMeasureThis');
  if (explainers?.length === 0) {
    return null;
  }

  return (
    <ExplainerPrimitive>
      <ExplainerTrigger data-testid='o-explainer'>{t('global.howDoWeMeasureThis')}</ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>{explainerTitle}</ExplainerTitle>
        <Stack className='items-start pb-6'>
          <ExplainerBody>
            {explainers.map((explainer, index) => (
              <div key={`explainer-${index}`}>
                <ExplainerCopy title={explainer.title} body={explainer.body} />
              </div>
            ))}
          </ExplainerBody>
          {externalLink && <MethodologyLink to={externalLink} />}
        </Stack>
      </ExplainerContent>
    </ExplainerPrimitive>
  );
};
